export default {
  getDisplay (state) {
    return state.display
  },
  getAccount (state) {
    return state.account
  }
}
